import { render } from "./ScrollTop.vue?vue&type=template&id=0d836178&scoped=true"
import script from "./ScrollTop.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollTop.vue?vue&type=script&setup=true&lang=js"

import "./ScrollTop.vue?vue&type=style&index=0&id=0d836178&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d836178"],['__file',"src/pages/components/parts/ScrollTop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d836178"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d836178', __exports__)) {
    console.log('reload')
    api.reload('0d836178', __exports__)
  }
  
  module.hot.accept("./ScrollTop.vue?vue&type=template&id=0d836178&scoped=true", () => {
    console.log('re-render')
    api.rerender('0d836178', render)
  })

}


export default __exports__